<template>
	<div>
		<v-row v-if="error_msg.length !== 0" class="ma-0">
			<v-col cols="12">
				<v-alert type="error" class="mb-0">
					{{ error_msg }}
				</v-alert>
			</v-col>
		</v-row>
		<ProgressLinear v-if="loading"/>
		<v-row v-if="!loading" class="ma-0">		
			<v-col v-if="$vuetify.breakpoint.smAndDown ? !is_create && event_type_id === 0 : true" :cols="$vuetify.breakpoint.smAndDown? 12:3">
				<v-row class="ma-0" justify="space-between">
					<v-btn class="text-capitalize white--text" :color="color" @click="is_create = true; event_type_id = 0">
						<v-icon>mdi-plus</v-icon>
						New Event Type
					</v-btn>
					<v-btn v-if="$vuetify.breakpoint.smAndDown" icon @click="$emit('close');">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-row>
				<div class="list-wrap" :style="`height: ${$vuetify.breakpoint.height - 260}px`">
					<div class="list-wrap-container">
						<v-expansion-panels
							v-model="panel"
							multiple
							accordion
							flat
						>
							<v-expansion-panel
								v-for="item in panel_items"
								:key="item.value"
							>
								<v-expansion-panel-header class="py-2 px-3" style="min-height: 48px;">
									<template v-slot:actions>
										<v-icon class="icon mr-2">$expand</v-icon>
									</template>
									<span class="header">{{ item.title }}</span>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-list-item-title v-for="event_type in group[`${item.value}`]" :key="event_type.id" class="task-status-hover rounded" @click="getEvent(event_type.id, event_type.type)">
										<span class="ml-2" :style="event_type.is_deleted === 1 ? 'color: #C4C4C4':''">{{event_type.desc }}</span>
										<span class="ml-2 rounded-pill inactive-text px-2" v-if="event_type.is_deleted === 1">Inactive</span>
									</v-list-item-title>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</div>
				</div>
			</v-col>
			<v-col v-if="$vuetify.breakpoint.smAndDown ? !is_create && event_type_id !== 0 : !is_create" :cols="$vuetify.breakpoint.smAndDown? 12:9">
				<div class="list-wrap" :style="`height: ${$vuetify.breakpoint.height - 224}px`">
					<div class="list-wrap-container">
						<v-row class="mt-0 mx-0 mb-3" justify="space-between">
							<v-row class="ma-0">
								<v-btn outlined class="text-capitalize" :color="color" @click="onDuplicate()">
									<v-icon small class="mr-1">mdi-content-copy</v-icon>
									Duplicate
								</v-btn>
								<v-btn outlined class="text-capitalize mx-3" :color="`#F45252`" @click="onDelete()">
									<v-icon size="20" class="mr-1">mdi-delete-outline</v-icon>
									Delete
								</v-btn>
								<v-btn v-if="isDetailChange && !$vuetify.breakpoint.smAndDown" class="text-capitalize white--text" :color="color" elevation="0" @click="onSaveChange()">
									<SaveIcon class="mr-1" :color="'white'" width="20" height="20"/>
									Save changes
								</v-btn>
							</v-row>
							<v-btn icon @click="onClose()">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-row>
						<v-row class="mt-3 mx-0 mb-2" v-if="isDetailChange && $vuetify.breakpoint.smAndDown">
							<v-btn block class="text-capitalize white--text" :color="color" elevation="0" @click="onSaveChange()">
								<SaveIcon class="mr-1" :color="'white'" width="20" height="20"/>
								Save changes
							</v-btn>
						</v-row>
						<ProgressLinear v-if="loading_event"/>
						<template v-if="!loading_event">
							<v-row class="ma-0" :align="`center`">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3" class="pl-0">
									<v-row class="ma-0">
										<div class="title-text title-text-color mr-2">
											Event type
										</div>
									</v-row>
									<v-select
										v-model="select_group"
										:items="panel_items"
										:menu-props="{ bottom: true, offsetY: true}"
										:color="color"
										background-color="#FAFAFA"
										:item-color="color"
										item-text="title"
										outlined
										dense
										hide-details
									>
									</v-select>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4" :class="$vuetify.breakpoint.smAndDown ? 'pl-0':''">
									<v-row class="ma-0">
										<div class="title-text mr-2" :class="!event_type_name || (event_type_name && event_type_name.length === 0) ? 'title-text-color-red' : 'title-text-color'">
											Event type name
										</div>
									</v-row>
									<v-text-field
										v-model="event_type_name"
										:color="color"
										:error="!event_type_name || (event_type_name && event_type_name.length === 0)"
										background-color="#FAFAFA"
										outlined
										hide-details
										clearable
										dense
									></v-text-field>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col cols="12" class="pl-0 pb-0">
									<div class="title-text title-text-color mr-2">
										Event description
									</div>
									<v-textarea
										v-model="event_type_note"
										:color="color"
										background-color="#FAFAFA"
										outlined
										hide-details
										clearable
										dense
										auto-grow
										rows="1"
									></v-textarea>
									<div style="text-align: right" class="optional-text">optional</div>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:2" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-checkbox
										v-model="event_type_inactive"
										:color="color"
										hide-details
										dense
									>
										<template v-slot:label>
											<span class="mr-2 checkbox-text">Mark as inactive</span>
										</template>
									</v-checkbox>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-checkbox
										v-model="event_type_complete"
										:color="color"
										:disabled="select_group !== 2"
										hide-details
										dense
									>
										<template v-slot:label>
											<span class="mr-2 checkbox-text" :style="select_group !== 2 ? 'color: rgba(25, 42, 62, 0.5)':''">Event is complete by default</span>
										</template>
									</v-checkbox>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3" class="py-0 pr-0" :class="$vuetify.breakpoint.smAndDown ? 'pl-1':'pl-3'">
									<v-checkbox
										v-model="event_type_multiple"
										:color="color"
										hide-details
										dense
									>
										<template v-slot:label>
											<span class="mr-2 checkbox-text">Allow inviting multiple people</span>
										</template>
									</v-checkbox>
								</v-col>
							</v-row>
							<v-row class="mx-0 my-2">
								<v-divider class="mx-0" style="border-color: #C4C4C4"></v-divider>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="px-0">
									<div class="checkbox-title">Dates</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'" align-self="center">
									<v-checkbox
										style="padding-top: 0; margin-top: 0;"
										v-model="event_type_date"
										:color="color"
										hide-details
										dense
									>
										<template v-slot:label>
											<span class="mr-2 item-text">Start and End dates optional</span>
										</template>
									</v-checkbox>
								</v-col>
								<v-col v-if="!event_type_recurring" :cols="$vuetify.breakpoint.smAndDown ? 12:3" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'" align-self="center">
									<v-checkbox
										v-if="select_group === 2"
										style="padding-top: 0; margin-top: 0;"
										v-model="event_type_due"
										:color="color"
										hide-details
										dense
									>
										<template v-slot:label>
											<span class="mr-2 item-text" :style="event_type_recurring ? 'opacity: 0.5':''">Due date</span>
										</template>
									</v-checkbox>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="px-0">
									<div class="checkbox-title">Times</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:11" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-radio-group
										style="margin-top: 0; padding-top: 0;"
										v-model="event_type_fullday"
										dense
										row
										hide-details
									>
										<v-radio
											value="full_day"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Full day event
												</span>
											</template>
										</v-radio>
										<v-radio
											value="duration"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Default event duration
												</span>
											</template>
										</v-radio>
									</v-radio-group>
									<v-row v-if="event_type_fullday === time_type.fullday" class="ma-0">
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:2" class="pl-0">
											<div class="item-text">Days</div>
											<v-text-field
												v-model="event_type_day"
												:color="color"
												background-color="#FAFAFA"
												outlined
												dense
												hide-details
												type="number"
												min="0"
												oninput="if(this.value < 0) this.value = 0; if(this.value >= 0) this.value = Number.parseInt(this.value)"
											></v-text-field>
										</v-col>
									</v-row>
									<v-row v-if="event_type_fullday === time_type.duration" class="ma-0">
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 6:2" class="pl-0">
											<div class="item-text">Hours</div>
											<v-text-field
												v-model="event_type_hour"
												:color="color"
												background-color="#FAFAFA"
												outlined
												dense
												hide-details
												type="number"
												min="0"
												step="1"
												oninput="if(this.value < 0) this.value = 0; if(this.value >= 0) this.value = Number.parseInt(this.value)"
											></v-text-field>
										</v-col>
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 6:2" :class="$vuetify.breakpoint.smAndDown ? 'pl-0':''">
											<div class="item-text">Minutes</div>
											<v-text-field
												v-model="event_type_minute"
												:color="color"
												background-color="#FAFAFA"
												outlined
												dense
												hide-details
												type="number"
												min="0"
												step="1"
												oninput="if(this.value < 0) this.value = 0; if(this.value >= 0) this.value = Number.parseInt(this.value)"
											></v-text-field>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="px-0">
									<div class="checkbox-title">Repeats</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:11" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-1':'px-0'" align-self="center">
									<v-row class="mx-0">
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 8:2" class="pl-0">
											<v-switch
												class="mt-0"
												v-model="event_type_recurring"
												:color="color"
												inset
												dense
												hide-details
											>
												<template v-slot:label>
													<span class="title-text" style="color: rgba(25, 42, 62, 1)">Make recurring</span>
												</template>
											</v-switch>
										</v-col>
									</v-row>
									<v-row v-if="event_type_recurring" class="ma-0">
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 6:2" class="pl-0">
											<div class="item-text">Repeat every</div>
											<v-text-field
												v-model="selected_repeat_digits"
												type="number"
												class="text-right"
												background-color="#FAFAFA"
												dense
												hide-details
												:color="color"
												outlined
												min="0"
												step="1"
												oninput="if(this.value < 0) this.value = 0; if(this.value >= 0) this.value = Number.parseInt(this.value)"
											/>
										</v-col>
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 6:2" :class="$vuetify.breakpoint.smAndDown ? 'pl-0':''">
											<div class="item-text" style="color:transparent">space</div>
											<v-select
												v-model="selected_repeat_frequency"
												:items="repeat_frequency"
												:menu-props="{ bottom: true, offsetY: true}"
												:color="color"
												:item-color="color"
												background-color="#FAFAFA"
												outlined
												dense
												hide-details
											>
											</v-select>
										</v-col>
									</v-row>
									<v-row v-if="event_type_recurring" class="ma-0">
										<v-checkbox
											v-model="lock_repeat"
											:color="color"
											hide-details
											dense
										>
											<template v-slot:label>
												<span class="mr-2 checkbox-text">Lock repeat</span>
												<v-tooltip right max-width="calc(55%)" z-index="11">
													<template v-slot:activator="{ on, attrs }">
														<div v-bind="attrs" v-on="on">
															<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
														</div>
													</template>
													<span>Check this box if you want all events of this type to have a fixed number of repeats, not editable by users of your organisation.</span>
												</v-tooltip>
											</template>
										</v-checkbox>
									</v-row>
								</v-col>
							</v-row>
							<v-row class="mx-0 my-2">
								<v-divider class="mx-0" style="border-color: #C4C4C4"></v-divider>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="px-0">
									<div class="checkbox-title">Alert</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:11" class="pa-0">
									<v-row class="ma-0">
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 6:2" class="pl-0">
											<v-text-field
												v-model="selected_alert_digits"
												type="number"
												class="text-right"
												background-color="#FAFAFA"
												dense
												hide-details
												:color="color"
												:disabled="alert_flag"
												outlined
												min="0"
												step="1"
												oninput="if(this.value < 0) this.value = 0; if(this.value >= 0) this.value = Number.parseInt(this.value)"
											/>
										</v-col>
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 6:2" :class="$vuetify.breakpoint.smAndDown ? 'pl-0':''">
											<v-select
												v-model="selected_alert_frequency"
												:items="alert_frequency"
												:menu-props="{ bottom: true, offsetY: true}"
												:color="color"
												:item-color="color"
												background-color="#FAFAFA"
												outlined
												dense
												hide-details
											>
											</v-select>
										</v-col>
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3" :class="$vuetify.breakpoint.smAndDown ? 'px-1':''" align-self="center">
											<div v-if="!alert_flag">before</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row class="mx-0 my-2">
								<v-divider class="mx-0" style="border-color: #C4C4C4"></v-divider>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="pa-0">
									<div class="checkbox-title">Address book field</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:6" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-radio-group
										style="margin-top: 0; padding-top: 0;"
										v-model="event_type_addbook"
										dense
										mandatory
									>
										<v-radio
											:value="field_type.required"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Required
												</span>
											</template>
										</v-radio>
										<v-radio
											:value="field_type.display"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Display, optional
												</span>
											</template>
										</v-radio>
										<v-radio
											:value="field_type.do_not_display"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Do not display
												</span>
											</template>
										</v-radio>
									</v-radio-group>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="pa-0">
									<div class="checkbox-title">Contact field</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:6" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-radio-group
										style="margin-top: 0; padding-top: 0;"
										v-model="event_type_contact"
										dense
										mandatory
										:disabled="event_type_addbook === field_type.do_not_display"
									>
										<v-radio
											:value="field_type.display"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Display, optional
												</span>
											</template>
										</v-radio>
										<v-radio
											:value="field_type.do_not_display"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Do not display
												</span>
											</template>
										</v-radio>
									</v-radio-group>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="pa-0">
									<div class="checkbox-title">Job field</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:6" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-radio-group
										style="margin-top: 0; padding-top: 0;"
										v-model="event_type_job"
										dense
										mandatory
										:disabled="event_type_addbook === field_type.do_not_display || event_type_addbook === field_type.display"
									>
										<v-radio
											:value="field_type.required"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Required
												</span>
											</template>
										</v-radio>
										<v-radio
											:value="field_type.do_not_display"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Do not display
												</span>
											</template>
										</v-radio>
									</v-radio-group>
								</v-col>
							</v-row>
							<v-row v-if="select_group !== 0" class="mx-0 my-2">
								<v-divider class="mx-0" style="border-color: #C4C4C4"></v-divider>
							</v-row>
							<v-row v-if="select_group !== 0" class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="pa-0">
									<div class="checkbox-title">Plan type</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:2" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-radio-group
										v-if="select_group === 2"
										style="margin-top: 0; padding-top: 0;"
										v-model="event_type_plan"
										dense
										mandatory
									>
										<v-radio
											:value="0"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text mr-2">Tentative</span>
												<v-tooltip right max-width="calc(55%)" z-index="11">
													<template v-slot:activator="{ on, attrs }">
														<div v-bind="attrs" v-on="on">
															<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
														</div>
													</template>
													<span>User’s time will be Available for other Tasks or Events. </span>
												</v-tooltip>
											</template>
										</v-radio>
										<v-radio
											:value="1"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text mr-2">Busy</span>
												<v-tooltip right max-width="calc(55%)" z-index="11">
													<template v-slot:activator="{ on, attrs }">
														<div v-bind="attrs" v-on="on">
															<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
														</div>
													</template>
													<span>User’s time will be Unavailable for other Tasks or Events. </span>
												</v-tooltip>
											</template>
										</v-radio>
									</v-radio-group>
									<v-radio-group
										v-if="select_group === 1"
										style="margin-top: 0; padding-top: 0;"
										v-model="event_type_plan"
										dense
										mandatory
									>
										<v-radio
											v-for="leave of leave_list"
											:key="leave.id"
											:value="leave.id"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text mr-2">{{ leave.short }}</span>
											</template>
										</v-radio>
									</v-radio-group>
								</v-col>
							</v-row>
						</template>
					</div>
				</div>
			</v-col>
			<v-col v-if="is_create" :cols="$vuetify.breakpoint.smAndDown? 12:9">
				<div class="list-wrap" :style="`height: ${$vuetify.breakpoint.height - 224}px`">
					<div class="list-wrap-container">
						<v-row class="ma-0" justify="space-between">
							<v-row class="ma-0">
								<v-btn class="text-capitalize white--text" :color="color" elevation="0" :disabled="!isCreateAvailable" @click="onCreate()">
									Save Event Type
								</v-btn>
							</v-row>
							<v-btn icon @click="onClose()">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-row>
						<ProgressLinear v-if="loading_event"/>
						<template v-if="!loading_event">
							<v-row class="ma-0" :align="`center`">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3" class="pl-0">
									<v-row class="ma-0">
										<div class="title-text title-text-color mr-2">
											Event type
										</div>
									</v-row>
									<v-select
										v-model="create_group"
										:items="panel_items"
										:menu-props="{ bottom: true, offsetY: true}"
										:color="color"
										background-color="#FAFAFA"
										:item-color="color"
										item-text="title"
										outlined
										dense
										hide-details
									>
									</v-select>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:4" :class="$vuetify.breakpoint.smAndDown ? 'pl-0':''">
									<v-row class="ma-0">
										<div class="title-text mr-2" :class="!create_type_name || (create_type_name && create_type_name.length === 0) ? 'title-text-color-red' : 'title-text-color'">
											Event type name
										</div>
									</v-row>
									<v-text-field
										v-model="create_type_name"
										:color="color"
										:error="!create_type_name || (create_type_name && create_type_name.length === 0)"
										background-color="#FAFAFA"
										outlined
										hide-details
										clearable
										dense
									></v-text-field>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col cols="12" class="pl-0 pb-0">
									<div class="title-text title-text-color mr-2">
										Event description
									</div>
									<v-textarea
										v-model="create_type_note"
										:color="color"
										background-color="#FAFAFA"
										outlined
										hide-details
										clearable
										dense
										auto-grow
										rows="1"
									></v-textarea>
									<div style="text-align: right" class="optional-text">optional</div>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:2" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-checkbox
										v-model="create_type_inactive"
										:color="color"
										hide-details
										dense
									>
										<template v-slot:label>
											<span class="mr-2 checkbox-text">Mark as inactive</span>
										</template>
									</v-checkbox>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-checkbox
										v-model="create_type_complete"
										:color="color"
										:disabled="create_group !== 2"
										hide-details
										dense
									>
										<template v-slot:label>
											<span class="mr-2 checkbox-text" :style="create_group !== 2 ? 'color: rgba(25, 42, 62, 0.5)':''">Event is complete by default</span>
										</template>
									</v-checkbox>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3" class="py-0 pr-0" :class="$vuetify.breakpoint.smAndDown ? 'pl-1':'pl-3'">
									<v-checkbox
										v-model="create_type_multiple"
										:color="color"
										hide-details
										dense
									>
										<template v-slot:label>
											<span class="mr-2 checkbox-text">Allow inviting multiple people</span>
										</template>
									</v-checkbox>
								</v-col>
							</v-row>
							<v-row class="mx-0 my-2">
								<v-divider class="mx-0" style="border-color: #C4C4C4"></v-divider>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="px-0">
									<div class="checkbox-title">Dates</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'" align-self="center">
									<v-checkbox
										style="padding-top: 0; margin-top: 0;"
										v-model="create_type_date"
										:color="color"
										hide-details
										dense
									>
										<template v-slot:label>
											<span class="mr-2 item-text">Start and End dates optional</span>
										</template>
									</v-checkbox>
								</v-col>
								<v-col v-if="!create_type_recurring" :cols="$vuetify.breakpoint.smAndDown ? 12:3" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'" align-self="center">
									<v-checkbox
										v-if="create_group === 2"
										style="padding-top: 0; margin-top: 0;"
										v-model="create_type_due"
										:color="color"
										hide-details
										dense
									>
										<template v-slot:label>
											<span class="mr-2 item-text" :style="create_type_recurring ? 'opacity: 0.5':''">Due date</span>
										</template>
									</v-checkbox>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="px-0">
									<div class="checkbox-title">Times</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:11" :class="$vuetify.breakpoint.smAndDown ? 'py-0 px-1':'px-0'">
									<v-radio-group
										style="margin-top: 0; padding-top: 0;"
										v-model="create_type_fullday"
										dense
										row
										hide-details
									>
										<v-radio
											value="full_day"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Full day event
												</span>
											</template>
										</v-radio>
										<v-radio
											value="duration"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Default event duration
												</span>
											</template>
										</v-radio>
									</v-radio-group>
									<v-row v-if="create_type_fullday === time_type.fullday" class="ma-0" :align="`center`">
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:2" class="pl-0">
											<div class="item-text">Days</div>
											<v-text-field
												v-model="create_type_day"
												:color="color"
												background-color="#FAFAFA"
												outlined
												dense
												hide-details
												type="number"
												min="0"
												oninput="if(this.value < 0) this.value = 0;"
											></v-text-field>
										</v-col>
									</v-row>
									<v-row v-if="create_type_fullday === time_type.duration" class="ma-0" :align="`center`">
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 6:2" class="pl-0">
											<div class="item-text">Hours</div>
											<v-text-field
												v-model="create_type_hour"
												:color="color"
												background-color="#FAFAFA"
												outlined
												dense
												hide-details
												type="number"
												min="0"
												oninput="if(this.value < 0) this.value = 0;"
											></v-text-field>
										</v-col>
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 6:2" :class="$vuetify.breakpoint.smAndDown ? 'pl-0':''">
											<div class="item-text">Minutes</div>
											<v-text-field
												v-model="create_type_minute"
												:color="color"
												background-color="#FAFAFA"
												outlined
												dense
												hide-details
												type="number"
												min="0"
												step="1"
												oninput="if(this.value < 0) this.value = 0; if(this.value >= 0) this.value = Number.parseInt(this.value)"
											></v-text-field>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="px-0">
									<div class="checkbox-title">Repeats</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:11" class="pa-0">
									<v-row :class="$vuetify.breakpoint.smAndDown ? 'mx-1 my-1':'mx-0 my-3'">
										<v-switch
											class="mt-0"
											v-model="create_type_recurring"
											:color="color"
											inset
											hide-details
											dense
										>
											<template v-slot:label>
												<span class="title-text" style="color: rgba(25, 42, 62, 1)">Make recurring</span>
											</template>
										</v-switch>
									</v-row>
									<v-row v-if="create_type_recurring" class="ma-0">
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 6:2" class="pl-0">
											<div class="item-text">Repeat every</div>
											<v-text-field
												v-model="create_repeat_digits"
												type="number"
												class="text-right"
												background-color="#FAFAFA"
												dense
												hide-details
												:color="color"
												outlined
												min="1"
												step="1"
												oninput="if(this.value < 0) this.value = 1; if(this.value >= 0) this.value = Number.parseInt(this.value)"
											/>
										</v-col>
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 6:2" :class="$vuetify.breakpoint.smAndDown ? 'pl-0':''">
											<div class="item-text" style="color:transparent">space</div>
											<v-select
												v-model="create_repeat_frequency"
												:items="repeat_frequency"
												:menu-props="{ bottom: true, offsetY: true}"
												:color="color"
												:item-color="color"
												background-color="#FAFAFA"
												outlined
												dense
												hide-details
											>
											</v-select>
										</v-col>
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:2" :class="$vuetify.breakpoint.smAndDown ? 'pl-0 py-0':''">
											<div v-if="!$vuetify.breakpoint.smAndDown" class="item-text" style="color:transparent">space</div>
											<v-checkbox
												v-model="create_repeat"
												:color="color"
												hide-details
												dense
											>
												<template v-slot:label>
													<span class="mr-2 checkbox-text">Lock repeat</span>
													<v-tooltip right max-width="calc(55%)" z-index="11">
														<template v-slot:activator="{ on, attrs }">
															<div class="mt-1" v-bind="attrs" v-on="on">
																<InfoOutline  width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
															</div>
														</template>
														<span>Check this box if you want all events of this type to have a fixed number of repeats, not editable by users of your organisation.</span>
													</v-tooltip>
												</template>
											</v-checkbox>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row class="mx-0 my-2">
								<v-divider class="mx-0" style="border-color: #C4C4C4"></v-divider>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="px-0">
									<div class="checkbox-title">Alert</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:11" class="pa-0">
									<v-row class="ma-0">
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 6:2" class="pl-0" :class="$vuetify.breakpoint.smAndDown ? 'py-0':''">
											<v-text-field
												v-model="create_alert_digits"
												type="number"
												class="text-right"
												background-color="#FAFAFA"
												dense
												hide-details
												:color="color"
												:disabled="create_alert_frequency === this.alert_frequency[this.alert_frequency.length - 1]"
												outlined
												min="0"
												step="1"
												oninput="if(this.value < 0) this.value = 0; if(this.value >= 0) this.value = Number.parseInt(this.value)"
											/>
										</v-col>
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 6:2" :class="$vuetify.breakpoint.smAndDown ? 'pl-0 py-0':''">
											<v-select
												v-model="create_alert_frequency"
												:items="alert_frequency"
												:menu-props="{ bottom: true, offsetY: true}"
												:color="color"
												:item-color="color"
												background-color="#FAFAFA"
												outlined
												dense
												hide-details
											>
											</v-select>
										</v-col>
										<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:3" :class="$vuetify.breakpoint.smAndDown ? 'px-1':''" align-self="center">
											<div v-if="create_alert_frequency !== this.alert_frequency[this.alert_frequency.length - 1]">before</div>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
							<v-row class="mx-0 my-2">
								<v-divider class="mx-0" style="border-color: #C4C4C4"></v-divider>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="pa-0">
									<div class="checkbox-title">Address book field</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:11" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-radio-group
										style="margin-top: 0; padding-top: 0;"
										v-model="create_type_addbook"
										dense
										mandatory
									>
										<v-radio
											:value="field_type.required"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Required
												</span>
											</template>
										</v-radio>
										<v-radio
											:value="field_type.display"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Display, optional
												</span>
											</template>
										</v-radio>
										<v-radio
											:value="field_type.do_not_display"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Do not display
												</span>
											</template>
										</v-radio>
									</v-radio-group>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="pa-0">
									<div class="checkbox-title">Contact field</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:11" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-radio-group
										style="margin-top: 0; padding-top: 0;"
										v-model="create_type_contact"
										dense
										mandatory
										:disabled="create_type_addbook === field_type.do_not_display"
									>
										<v-radio
											:value="field_type.display"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Display, optional
												</span>
											</template>
										</v-radio>
										<v-radio
											:value="field_type.do_not_display"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Do not display
												</span>
											</template>
										</v-radio>
									</v-radio-group>
								</v-col>
							</v-row>
							<v-row class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="pa-0">
									<div class="checkbox-title">Job field</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:11" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-radio-group
										style="margin-top: 0; padding-top: 0;"
										v-model="create_type_job"
										dense
										mandatory
										:disabled="create_type_addbook === field_type.do_not_display || create_type_addbook === field_type.display"

									>
										<v-radio
											:value="field_type.required"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Required
												</span>
											</template>
										</v-radio>
										<v-radio
											:value="field_type.do_not_display"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text">
													Do not display
												</span>
											</template>
										</v-radio>
									</v-radio-group>
								</v-col>
							</v-row>
							<v-row v-if="create_group !== 0" class="mx-0 my-2">
								<v-divider class="mx-0" style="border-color: #C4C4C4"></v-divider>
							</v-row>
							<v-row v-if="create_group !== 0" class="ma-0">
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:1" class="pa-0">
									<div class="checkbox-title">Plan type</div>
								</v-col>
								<v-col :cols="$vuetify.breakpoint.smAndDown ? 12:2" :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-0':'pa-0'">
									<v-radio-group
										v-if="create_group === 2"
										style="margin-top: 0; padding-top: 0;"
										v-model="create_type_plan"
										dense
										mandatory
									>
										<v-radio
											:value="0"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text mr-2">Tentative</span>
												<v-tooltip right max-width="calc(55%)" z-index="11">
													<template v-slot:activator="{ on, attrs }">
														<div v-bind="attrs" v-on="on">
															<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
														</div>
													</template>
													<span>User’s time will be Available for other Tasks or Events. </span>
												</v-tooltip>
											</template>
										</v-radio>
										<v-radio
											:value="1"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text mr-2">Busy</span>
												<v-tooltip right max-width="calc(55%)" z-index="11">
													<template v-slot:activator="{ on, attrs }">
														<div v-bind="attrs" v-on="on">
															<InfoOutline class="mt-1" width="14" height="14" color="rgba(25, 42, 62, 0.5)"/>
														</div>
													</template>
													<span>User’s time will be Unavailable for other Tasks or Events. </span>
												</v-tooltip>
											</template>
										</v-radio>
									</v-radio-group>
									<v-radio-group
										v-if="create_group === 1"
										style="margin-top: 0; padding-top: 0;"
										v-model="create_type_plan"
										dense
										mandatory
									>
										<v-radio
											v-for="leave of leave_list"
											:key="leave.id"
											:value="leave.id"
											:color="color"
										>
											<template v-slot:label>
												<span class="item-text mr-2">{{ leave.short }}</span>
											</template>
										</v-radio>
									</v-radio-group>
								</v-col>
							</v-row>
						</template>
					</div>
				</div>
			</v-col>
		</v-row>
		<DialogNotice
			v-if="visible_notice" 
			:visible="visible_notice" 
			:text="notice_text"
		/>
		<DeleteConfirmDialog 
			v-if="unsaved_visible"
			:visible="unsaved_visible" 
			:color="'error'"
			:title="`Your changes have not been saved`" 
			:content="'Are you sure you want to leave this page without saving changes?'"
			:cancel="'Go back'"
			:ok="'Yes, leave'"
			:icon_name_title="'mdi-alert-circle'"
			:maxWidth="500"
			@cancel="unsaved_visible = false"
			@ok="onLeave()"
		/>
		<DeleteConfirmDialog 
			v-if="delete_visible"
			:visible="delete_visible" 
			:color="'error'"
			:title="del_title" 
			:content="del_content"
			:cancel="'Go back'"
			:ok="del_ok"
			:icon_name_title="'mdi-alert-circle'"
			:maxWidth="500"
			@cancel="delete_visible = false"
			@ok="onDeleteEvent()"
		/>
	</div>
</template>

<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import SaveIcon from "@/components/icons/save.vue";
import InfoOutline from "@/components/icons/info_outline";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import DeleteConfirmDialog from "@/components/dialogs/delete_comfirm_dialog.vue";

const Panel_Items = [
	{
		title: 'Public Holidays',
		value: 0
	},
	{
		title: 'Leave',
		value: 1
	},
	{
		title: 'Other',
		value: 2
	},
];

const Other_Type = 2;

/** from 'src/db/models/event.rs' */
const Leave_Type = 2;
const Public_Leave = 3;
/** from rust */
const Link_Type = {
	none: 0,
	optional: 1,
	mandatory: 2,
	mandatory_job: 3,
};

const Field_Type = {
	do_not_display: 0,
	display: 1,
	required: 2,
};
const Alert_None = -1;

const Time_Type = {
	fullday: 'full_day',
	duration: 'duration',
};
const Repeat_Frequency = ['Days', 'Weekdays', 'Months', 'Years', 'Weeks'];
const Alert_Frequency = ['minute(s)', 'hour(s)', 'day(s)', 'None'];
const Minutes_Day = 60 * 24;

export default {
	name: 'EventType',
	components: {
		ProgressLinear,
		SaveIcon,
		InfoOutline,
		DialogNotice,
		DeleteConfirmDialog
	},
	props: {
		color: {
			type: String,
			default: ''
		}
	},
	data() {
		this.panel_items = Panel_Items;
		this.repeat_frequency = Repeat_Frequency;
		this.time_type = Time_Type;
		this.link_type = Link_Type;
		this.field_type = Field_Type;
		this.leave_type = Leave_Type;
		this.alert_none = Alert_None;
		this.alert_frequency = Alert_Frequency;

		return {
			error_msg: '',
			loading: false,
			loading_event: false,

			panel: this.id === 0 ? [0] :Panel_Items.map((k, i) => { return i}),
			group: null,
			event_types: [],
			leave_list: [],
			public_leave_kind: 0,
			
			origin_event: [],
			event_type_id: 0,
			select_group: 0,
			event_type_name: '',
			event_type_note: '',
			event_type_inactive: false,
			event_type_complete: false,
			event_type_multiple: false,

			event_type_date: false,
			event_type_due: false,

			event_type_fullday: Time_Type.duration,
			event_type_day: 0,
			event_type_hour: 0,
			event_type_minute: 0,

			event_type_recurring: false,
			lock_repeat: false,
			selected_repeat_digits: 0,
			selected_repeat_frequency: '',

			alert_flag: false,
			selected_alert_digits: 1,
			selected_alert_frequency: Alert_Frequency[0],

			event_type_addbook: Link_Type.none,
			event_type_contact: Link_Type.none,
			event_type_job: Link_Type.none,
			event_type_plan: 0,

			is_create: false,
			create_group: (Panel_Items[Panel_Items.length - 1]).value,
			create_type_name: '',
			create_type_note: '',
			create_type_inactive: false,
			create_type_complete: false,
			create_type_multiple: false,

			create_type_date: false,
			create_type_due: false,

			create_type_fullday: Time_Type.duration,
			create_type_day: 0,
			create_type_hour: 0,
			create_type_minute: 0,
			
			create_type_recurring: false,
			create_repeat_digits: 1,
			create_repeat_frequency: Repeat_Frequency[0],
			create_repeat: false,

			create_alert_digits: 0,
			create_alert_frequency: Alert_Frequency[Alert_Frequency.length - 1],

			create_type_addbook: Link_Type.none,
			create_type_contact: Link_Type.none,
			create_type_job: Link_Type.none,
			create_type_plan: 0,

			del_title: '',
			del_content: '',
			del_ok: '',

			visible_notice: false,
			notice_text: [],
			tid: null,

			unsaved_visible: false,
			delete_visible: false,
		}
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	async created() {
		await this.getEventTypeList();
		await this.getLeaveKinds();
		
		if (!this.$vuetify.breakpoint.smAndDown) {
			const first_key = (Object.keys(this.group))[0];
			const first_arr = this.group[`${first_key}`];

			const second_key = (Object.keys(this.group))[1];
			const second_arr = this.group[`${second_key}`];

			const open_event = first_arr.length > 0 ? first_arr[0] : second_arr[0];
			this.getEvent(open_event.id, open_event.type);
		}
	},
	computed: {
		isDetailChange() {
			let is_change = false;

			if (this.event_type_id !== 0) {
				const is_deleted = this.event_type_inactive ? 1: 0;
				const date_optional = this.event_type_date ? 1: 0;
				const has_due = this.event_type_due ? 1: 0;
				const is_wholeday = this.event_type_fullday === Time_Type.fullday ? true: false;
				const is_recurring = this.origin_event.repeat_unit === 0 && this.origin_event.repeat_value === 0 ? false : true;
				const duration = this.event_type_fullday === Time_Type.fullday ? Number(this.event_type_day * Minutes_Day) : (Number(this.event_type_hour * 60) + Number(this.event_type_minute));
				const repeat_unit = Repeat_Frequency.findIndex(f => { return f === this.selected_repeat_frequency }) + 1;
				const repeat_value = repeat_unit === 0 ? 0 : Number(this.selected_repeat_digits);
				const alert_frequency = this.selected_alert_frequency === Alert_Frequency[Alert_Frequency.length -1] ? -1 : this._getMinutes(this.selected_alert_digits ,this.selected_alert_frequency);
				const is_contact_needed = this.event_type_contact === Field_Type.do_not_display ? false : true;

				let event_type_field = 0;
				if (this.event_type_addbook === Field_Type.do_not_display && this.event_type_job === Field_Type.do_not_display) {
					event_type_field = Link_Type.none;
				}
				if (this.event_type_addbook === Field_Type.display && this.event_type_job === Field_Type.do_not_display) {
					event_type_field = Link_Type.optional;
				}
				if (this.event_type_addbook === Field_Type.required && this.event_type_job === Field_Type.do_not_display) {
					event_type_field = Link_Type.mandatory;
				}
				if (this.event_type_addbook === Field_Type.required && this.event_type_job === Field_Type.required) {
					event_type_field = Link_Type.mandatory_job;
				}
				

				if (this.origin_event.type !== this.select_group
					|| (this.origin_event.desc !== this.event_type_name && this.event_type_name)
					|| (this.origin_event.comm !== this.event_type_note && this.event_type_note)
					|| this.origin_event.is_deleted !== is_deleted
					|| this.origin_event.pre_tick !== this.event_type_complete
					|| this.origin_event.can_invitemultiple !== this.event_type_multiple
					|| this.origin_event.date_optional !== date_optional
					|| this.origin_event.has_due !== has_due
					|| this.origin_event.is_wholeday !== is_wholeday
					|| is_recurring !== this.event_type_recurring
					|| Number(this.origin_event.duration) !== duration
					|| (is_recurring === this.event_type_recurring && (this.origin_event.repeat_value !== repeat_value || this.origin_event.repeat_unit !== repeat_unit))
					|| this.origin_event.fix_repeatunit !== this.lock_repeat
					|| this.origin_event.alert !== alert_frequency
					|| this.origin_event.links !== event_type_field
					|| this.origin_event.is_contact_needed !== is_contact_needed
					|| this.origin_event.type === Other_Type && this.origin_event.plan_type !== this.event_type_plan
					|| this.origin_event.type !== Other_Type && this.select_group === 1 && this.origin_event.leave_kind.id !== this.event_type_plan
				) {
					is_change = true;
				}
			}

			return is_change;
		},
		isCreateAvailable() {
			let is_available = false;
			if (this.is_create) {
				if (this.create_type_name && this.create_type_name.length !== 0) {
					is_available = true;
				}
			}
			return is_available;
		},
	},
	watch: {
		isDetailChange() {
			this.$emit('change', this.isDetailChange);
		},
		is_create() {
			this.$emit('change', this.is_create);
		},
		selected_alert_frequency() {
			if (this.selected_alert_frequency === Alert_Frequency[Alert_Frequency.length -1]) {
				this.selected_alert_digits = null;
				this.alert_flag = true;
			} else {
				this.alert_flag = false;
			}
		},
		event_type_addbook() {
			if (this.event_type_addbook === Field_Type.do_not_display) {
				this.event_type_contact = Field_Type.do_not_display;
				this.event_type_job = Field_Type.do_not_display;
			}

			if (this.event_type_addbook === Field_Type.display) {
				this.event_type_job = Field_Type.do_not_display;
			}
		},
		create_type_addbook() {
			if (this.create_type_addbook === Field_Type.do_not_display) {
				this.create_type_contact = Field_Type.do_not_display;
				this.create_type_job = Field_Type.do_not_display;
			}

			if (this.create_type_addbook === Field_Type.display) {
				this.create_type_job = Field_Type.do_not_display;
			}
		}
	},
	methods: {
		async getLeaveKinds() {
			this.loading = true;

			const url = "/api/kinds/leave";

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status == "OK") {
						this.leave_list = data.filter(d => { return d.leave_type !== Public_Leave });

						const public_leave_kind = data.filter(d => { return d.leave_type === Public_Leave });
						this.public_leave_kind = public_leave_kind[0].id;
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async getEventTypeList() {
			this.loading = true;

			const params = [];
			params.push("include_inactive=true");

			let url = "/api/config/eventtype";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status == "OK") {
						data.forEach(d => { 
							d['type'] = this._getType(d.leave_type);
						});

						const un_delete = data.filter(d => { return d.is_deleted === 0 });
						const deleted = data.filter(d => { return d.is_deleted === 1 });
						this.event_types = [...un_delete, ...deleted];

						const status_group_obj = {};
						this.panel_items.forEach(element => {
							status_group_obj[`${element.value}`] = [];
						});

						this.event_types.forEach(d => {
							(status_group_obj[`${d.type}`]).push(d);
						});

						this.group = status_group_obj;	
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getEvent(id, type) {
			this.error_msg = '';
			this.loading_event = true;

			const url = `/api/config/eventtype/${id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					let json = val.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					const { status, data, reason } = json;
					if (status == "OK") {
						data['type'] = type;
						this.origin_event = data;

						this.onShowEventType(data, data.type);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading_event = false;
				});
		},
		onShowEventType(event, group_value) {
			if (this.is_create) {
				this.is_create = false;
			};

			this.select_group = group_value;
			this.event_type_id = event.id;
			this.event_type_name = event.desc;
			this.event_type_note = event.comm;
			this.event_type_inactive = event.is_deleted === 0 ? false : true;
			this.event_type_complete = event.pre_tick;
			this.event_type_multiple = event.can_invitemultiple;

			this.event_type_date = event.date_optional === 0 ? false: true;
			this.event_type_due = event.has_due === 0 ? false: true;

			if (event.is_wholeday) {
				this.event_type_day = Number(event.duration) / Minutes_Day;
			} else {
				const duration = this._minutesToBudget(Number(event.duration));
				this.event_type_hour = duration.hours;
				this.event_type_minute = duration.mins;
			}
			this.event_type_fullday = event.is_wholeday ? Time_Type.fullday : Time_Type.duration;

			this.event_type_recurring = event.repeat_unit === 0 && event.repeat_value === 0 ? false : true;
			if (this.event_type_recurring) {
				if (event.repeat_unit === 0) {
					this.selected_repeat_digits = 0;
					this.selected_repeat_frequency = '';
				} else {
					this.selected_repeat_digits = event.repeat_value;
					this.selected_repeat_frequency = Repeat_Frequency[event.repeat_unit - 1];
				}
			} else {
				this.selected_repeat_digits = 1;
				this.selected_repeat_frequency = Repeat_Frequency[0];
			}

			this.lock_repeat = event.fix_repeatunit;

			this.alert_flag = event.alert === Alert_None ? true : false;
			const alert = this._minutesToAlert(event.alert);
			this.selected_alert_digits = alert.num;
			this.selected_alert_frequency = alert.unit;

			if (event.links === Link_Type.none) {
				this.event_type_addbook = Field_Type.do_not_display;
				this.event_type_job = Field_Type.do_not_display;
			}
			if (event.links === Link_Type.optional) {
				this.event_type_addbook = Field_Type.display;
				this.event_type_job = Field_Type.do_not_display;
			}
			if (event.links === Link_Type.mandatory) {
				this.event_type_addbook = Field_Type.required;
				this.event_type_job = Field_Type.do_not_display;
			}
			if (event.links === Link_Type.mandatory_job) {
				this.event_type_addbook = Field_Type.required;
				this.event_type_job = Field_Type.required;
			}

			if (event.is_contact_needed) {
				this.event_type_contact = Field_Type.display;
			} else {
				this.event_type_contact = Field_Type.do_not_display;
			}

			/** 0-tentative, 1-busy, 2 - leave */
			this.event_type_plan = event.leave_kind ? event.leave_kind.id : event.plan_type;
		},
		onDuplicate() {
			this.create_group = this.select_group;
			this.create_type_name = this.event_type_name;
			this.create_type_note = this.event_type_note;

			this.create_type_inactive = this.event_type_inactive;
			this.create_type_complete = this.event_type_complete;
			this.create_type_multiple = this.event_type_multiple;

			this.create_type_date = this.event_type_date;
			this.create_type_due = this.event_type_due;

			this.create_type_fullday = this.event_type_fullday;
			this.create_type_day = this.event_type_day;
			this.create_type_hour = this.event_type_hour;
			this.create_type_minute = this.event_type_minute;

			this.create_type_recurring = this.event_type_recurring;
			this.create_repeat_digits = this.selected_repeat_digits;
			this.create_repeat_frequency = this.selected_repeat_frequency;
			this.create_repeat = this.lock_repeat;

			this.create_alert_digits = this.selected_alert_digits;
			this.create_alert_frequency = this.selected_alert_frequency;

			this.create_type_addbook = this.event_type_addbook;
			this.create_type_contact = this.event_type_contact;
			this.create_type_job = this.event_type_job;
			this.create_type_plan = this.event_type_plan;

			this.is_create = true;
		},
		onSaveChange() {
			const param_obj = {};
			param_obj['description'] = this.event_type_name;

			const is_wholeday = this.event_type_fullday === Time_Type.fullday ? true : false;
			param_obj['is_wholeday'] = is_wholeday;

			param_obj['can_invitemultiple'] = this.event_type_multiple;

			const value_arr = is_wholeday ? [this.event_type_day] :[this.event_type_hour, this.event_type_minute];
			param_obj['duration'] = this._getDuration(value_arr);

			param_obj['alert'] = this.selected_alert_frequency === Alert_Frequency[Alert_Frequency.length -1] ? -1 : this._getMinutes(this.selected_alert_digits ,this.selected_alert_frequency);
			param_obj['fix_repeatunit'] = this.lock_repeat;
			
			const repeat_unit = Repeat_Frequency.findIndex(name => { return name === this.selected_repeat_frequency}) + 1;
			param_obj['repeat_unit'] = this.event_type_recurring ? repeat_unit : 0;
			param_obj['repeat_value'] = this.event_type_recurring ? Number(this.selected_repeat_digits) : 0;

			param_obj['plan_type'] = this.select_group === Other_Type ? this.event_type_plan: Leave_Type;

			if (this.select_group !== Other_Type) {
				param_obj['leave_kind'] = this.select_group === 0 ? this.public_leave_kind :this.event_type_plan;
			}
					
			let event_type_field = 0;
			if (this.event_type_addbook === Field_Type.do_not_display && this.event_type_job === Field_Type.do_not_display) {
				event_type_field = Link_Type.none;
			}
			if (this.event_type_addbook === Field_Type.display && this.event_type_job === Field_Type.do_not_display) {
				event_type_field = Link_Type.optional;
			}
			if (this.event_type_addbook === Field_Type.required && this.event_type_job === Field_Type.do_not_display) {
				event_type_field = Link_Type.mandatory;
			}
			if (this.event_type_addbook === Field_Type.required && this.event_type_job === Field_Type.required) {
				event_type_field = Link_Type.mandatory_job;
			}
			param_obj['links'] = event_type_field;

			param_obj['comment'] = this.event_type_note;
			param_obj['is_deleted'] = this.event_type_inactive ? 1:0;
			param_obj['has_due'] = this.select_group === Other_Type ? (this.event_type_due ? 1:0) : 0;
			param_obj['date_optional'] = this.event_type_date ? 1:0;
			param_obj['pre_tick'] = this.select_group === Other_Type ? this.event_type_complete : false;
			param_obj['is_contact_needed'] = this.event_type_contact === Field_Type.do_not_display ? false : true;

			this._changeEventType(this.event_type_id, param_obj);
		},
		onDelete() {
			const is_used = this.origin_event.is_used;

			if (is_used) {
				this.del_title = 'Event Type in use';
				this.del_content = 'This Event Type cannot be deleted as it is in use. It can be marked inactive, if you don’t want it to be used for future Jobs.';
				this.del_ok = 'Mark inactive';
				this.delete_visible = true;
			} else {
				this.del_title = `You are about to delete Event Type ‘${this.origin_event.desc}’`;
				this.del_content = 'This action cannot be undone. Are you sure?';
				this.del_ok = 'Yes, delete';
				this.delete_visible = true;
			}
		},
		onDeleteEvent() {
			this._deleteEventType(this.origin_event)
		},
		onCreate() {
			const param_obj = {};
			param_obj['description'] = this.create_type_name;
			param_obj['is_wholeday'] = this.create_type_fullday === Time_Type.fullday ? true: false;
			param_obj['can_invitemultiple'] = this.create_type_multiple;

			const value_arr = this.create_type_fullday === Time_Type.fullday ? [this.create_type_day] :[this.create_type_hour, this.create_type_minute];
			param_obj['duration'] = this._getDuration(value_arr);

			param_obj['alert'] = this.create_alert_frequency === Alert_Frequency[Alert_Frequency.length -1] ? -1 : this._getMinutes(this.create_alert_digits ,this.create_alert_frequency);
			param_obj['fix_repeatunit'] = this.create_repeat;
			param_obj['repeat_value'] = this.create_type_recurring ? Number(this.create_repeat_digits) : 0;
			param_obj['repeat_unit'] = this.create_type_recurring ? Number(Repeat_Frequency.findIndex(name => { return name === this.create_repeat_frequency}) + 1) : 0;

			param_obj['plan_type'] = this.create_group === Other_Type ? this.create_type_plan: Leave_Type;

			if (this.create_group !== Other_Type) {
				param_obj['leave_kind'] = this.create_group === 0 ? this.public_leave_kind :this.create_type_plan;
			}

			let create_type_field = 0;
			if (this.create_type_addbook === Field_Type.do_not_display && this.create_type_job === Field_Type.do_not_display) {
				create_type_field = Link_Type.none;
			}
			if (this.create_type_addbook === Field_Type.display && this.create_type_job === Field_Type.do_not_display) {
				create_type_field = Link_Type.optional;
			}
			if (this.create_type_addbook === Field_Type.required && this.create_type_job === Field_Type.do_not_display) {
				create_type_field = Link_Type.mandatory;
			}
			if (this.create_type_addbook === Field_Type.required && this.create_type_job === Field_Type.required) {
				create_type_field = Link_Type.mandatory_job;
			}
			param_obj['links'] = create_type_field;

			param_obj['comment'] = this.create_type_note;
			param_obj['is_deleted'] = this.create_type_inactive ? 1:0;
			param_obj['has_due'] = this.create_group === Other_Type ? (this.create_type_due ? 1:0) : 0;
			param_obj['date_optional'] = this.create_type_date ? 1:0;

			param_obj['pre_tick'] = this.create_group === Other_Type ? this.create_type_complete : false;
			param_obj['is_contact_needed'] = this.create_type_contact === Field_Type.do_not_display ? false : true;

			const url = `/api/config/eventtype`;

			axios
				.post(url, param_obj, {
					headers: {
						Authorization: 'Bearer ' + this.$store.state.token,
						Accept: 'application/json',
					},
				})
				.then((val) => {
					const {status, reason} = val.data;

					if (status == "OK") {
						this._initCreateSettings();
						this.getEventTypeList();

						this.notice_text.push('Event Type has been created successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);

						if (this.$vuetify.breakpoint.smAndDown) {
							this._initEditSettings();
							this._initCreateSettings();
						} else {
							const first_key = (Object.keys(this.group))[0];
							const first_arr = this.group[`${first_key}`];

							const second_key = (Object.keys(this.group))[1];
							const second_arr = this.group[`${second_key}`];

							const open_event = first_arr.length > 0 ? first_arr[0] : second_arr[0];
							this.getEvent(open_event.id, open_event.type);
						}

					} else {
						this.error_msg = reason;
					}
					
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		onClose() {
			if (this.isDetailChange || this.isCreateAvailable) {
				this.unsaved_visible = true;
			} else {
				if (this.$vuetify.breakpoint.smAndDown) {
					this._initEditSettings();
					this._initCreateSettings();						
				} else {
					this.$emit('close');
				}
			}
		},
		onLeave() {
			if (this.$vuetify.breakpoint.smAndDown) {
				this.unsaved_visible = false;
				this._initEditSettings();
				this._initCreateSettings();
			} else {
				this.$emit('close');
			}
		},
		async _changeEventType(id, param_obj) {
			const url = `/api/config/eventtype/${id}`;

			axios
				.put(url, param_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason} = val.data;
					if (status == "OK") {
						this.getEventTypeList();

						this.notice_text.push('Event Type has been updated successfully');
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);	

						if (this.delete_visible) {
							this.delete_visible = false;

							if (this.$vuetify.breakpoint.smAndDown) {
								this.unsaved_visible = false;
								this._initEditSettings();
							} else {
								const first_key = (Object.keys(this.group))[0];
								const first_arr = this.group[`${first_key}`];

								const second_key = (Object.keys(this.group))[1];
								const second_arr = this.group[`${second_key}`];

								const open_event = first_arr.length > 0 ? first_arr[0] : second_arr[0];
								this.getEvent(open_event.id, open_event.type);
							}
							
						} else {
							if (this.$vuetify.breakpoint.smAndDown) {
								this.unsaved_visible = false;
								this._initEditSettings();
							} else {
								const open_event = this.event_types.filter(e => { return e.id === data.id });
								this.getEvent(open_event[0].id, open_event[0].type);
							}
						}
										
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
		},
		_deleteEventType(event_type) {
			const url = `/api/config/eventtype/${event_type.id}`;

			axios
				.delete(url, {
				}, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, reason} = val.data;

					if (status == "OK") {
						this.delete_visible = false;

						this.getEventTypeList();

						if (event_type.is_used) {
							this.notice_text.push('Event Type has been marked successfully');
						} else {
							this.notice_text.push('Event Type has been deleted successfully');
						}
						this.visible_notice = true;
						this.tid = setTimeout(this._close, 2000);
						
						if (this.$vuetify.breakpoint.smAndDown) {
							this.unsaved_visible = false;
							this._initEditSettings();
							
						} else {
							const first_key = (Object.keys(this.group))[0];
							const first_arr = this.group[`${first_key}`];

							const second_key = (Object.keys(this.group))[1];
							const second_arr = this.group[`${second_key}`];

							const open_event = first_arr.length > 0 ? first_arr[0] : second_arr[0];
							this.getEvent(open_event.id, open_event.type);
						}						

					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
		},
		_getType(leave_type) {
			/** type(Panel_Items) => Public Holidays = 0, Leave = 1,  Other = 2 */
			/** 0 = Not leave, 1 = Annual Leave, 2 = Personal leave, 3 = Public Holiday, 4 = Long service leave, 5 = Unpaid leave, 255 = Other leave */
			let type = 0;
			if (leave_type === 0) {
				type = 2;
			} else {
				if (leave_type === 3) {
					type = 0;
				} else {
					type = 1;
				}
			}
			return type;
		},
		_minutesToBudget(value) {
			let result = {
				hours: 0,
				mins: 0
			};

			if (value < 60 && value >= 0) {
				result.mins = value;
			}

			if (value >= 60) {
				const hours = Math.floor(value / 60);
				const minutes = value - (hours * 60);
				if (minutes > 0) {
					result.hours = hours;
					result.mins = minutes;
				} else {
					result.hours = hours;
				}
			}

			return result;
		},
		_minutesToAlert(value) {
			let result = {
				num: 0,
				unit: this.alert_frequency[0]
			};

			if (value === this.alert_none) {
				result.num = null;
				result.unit = this.alert_frequency[this.alert_frequency.length - 1];
			}

			if (value === 0) {
				result.num = 0;
				result.unit = this.alert_frequency[0];
			}

			if (value < 60 && value > 0) {
				result.num = value;
				result.unit = this.alert_frequency[0];
			}

			if (value >= 60 && value < Minutes_Day) {
				if (Number.isInteger(value / 60)) {
					const hours = Math.floor(value / 60);
					result.num = hours;
					result.unit = this.alert_frequency[1];
				} else {
					result.num = value;
					result.unit = this.alert_frequency[0];
				}
			}

			if (value >= Minutes_Day) {
				if (Number.isInteger(value / Minutes_Day)) {
					const days = Math.floor(value / Minutes_Day);
					result.num = days;
					result.unit = this.alert_frequency[2];
				} else {
					result.num = value;
					result.unit = this.alert_frequency[0];
				}
			}

			return result;
		},
		_getMinutes(value, unit) {
			let minutes = 0;

			if (unit === Alert_Frequency[0]) {
				minutes = value;
			}

			if (unit === Alert_Frequency[1]) {
				minutes = value * 60;
			}

			if (unit === Alert_Frequency[2]) {
				minutes = value * Minutes_Day;
			}

			return Number(minutes);
		},
		_getDuration(value_arr=[]) {
			let duration = 0;

			if (value_arr.length !== 0) {
				if (value_arr.length === 1) {
					duration = value_arr[0] * Minutes_Day;
				} 
				if (value_arr.length === 2) {
					duration = Number(value_arr[0] * 60) + Number(value_arr[1]);
				}
			}

			return Number(duration);
		},
		_close() {
			this.visible_notice = false;
			this.notice_text = [];
		},
		_initEditSettings() {
			this.origin_event = [];
			this.event_type_id = 0;
			this.select_group = 0;
			this.event_type_name = '';
			this.event_type_note = '';
			this.event_type_inactive = false;
			this.event_type_complete = false;
			this.event_type_multiple = false;
			this.event_type_date = false;
			this.event_type_due = false;
			this.event_type_fullday = Time_Type.duration;
			this.event_type_day = 0;
			this.event_type_hour = 0;
			this.event_type_minute = 0;
			this.event_type_recurring = false;
			this.lock_repeat = false;
			this.selected_repeat_digits = 1;
			this.selected_repeat_frequency = '';
			this.alert_flag = false;
			this.selected_alert_digits = 1;
			this.selected_alert_frequency = Alert_Frequency[0];
			this.event_type_addbook = Link_Type.none;
			this.event_type_contact = Link_Type.none;
			this.event_type_job = Link_Type.none;
			this.event_type_plan = 0;
		},
		_initCreateSettings() {
			this.is_create = false;
			this.create_group = (Panel_Items[Panel_Items.length - 1]).value;
			this.create_type_name = '';
			this.create_type_note = '';
			this.create_type_inactive = false;
			this.create_type_complete = false;
			this.create_type_multiple = false;
			this.create_type_date = false;
			this.create_type_due = false;
			this.create_type_fullday = Time_Type.duration;
			this.create_type_day = 0;
			this.create_type_hour = 0;
			this.create_type_minute = 0;
			this.create_type_recurring = false;
			this.create_repeat_digits = 1;
			this.create_repeat_frequency = Repeat_Frequency[0];
			this.create_repeat = false;
			this.create_alert_digits = 0;
			this.create_alert_frequency = Alert_Frequency[Alert_Frequency.length - 1];
			this.create_type_addbook = Link_Type.none;
			this.create_type_contact = Link_Type.none;
			this.create_type_job = Link_Type.none;
			this.create_type_plan = 0;
		}
	}
}
</script>

<style lang="scss" scoped>
	.list-wrap {
		overflow: auto;
	}
	.list-wrap-container {
		height: 99%;
	}
	.title-text {
		font-family: Roboto;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.25px;
	}
	.title-text-color {
		color: rgba(55, 73, 95, 1);
	}
	.title-text-color-red {
		color: rgba(244, 82, 82, 1);
	}
	.inactive-text {
		background-color: rgba(25, 42, 62, 0.15);
		font-family: Roboto;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		color: rgba(255, 255, 255, 1);
	}
	.default-text {
		background-color: rgba(220, 220, 220, 1);
		font-family: Roboto;
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		color: rgba(25, 42, 62, 1);
	}
	.checkbox-text {
		font-family: Roboto;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.25px;
		color: rgba(25, 42, 62, 1);
	}
	.checkbox-title {
		font-family: Roboto;
		font-size: 14px;
		font-weight: 500;
		line-height: 20px;
		letter-spacing: 0.25px;
		color: rgba(25, 42, 62, 1);
	}
	.item-text {
		font-family: Roboto;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		letter-spacing: 0.25px;
		color: rgba(55, 73, 95, 1);
	}
	.optional-text {
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 20px;

		text-align: right;
		letter-spacing: 0.4px;
		color: #37495F;
	}
	.task-status-hover {
		&:hover {
			background-color: #FAFAFA;
			cursor: pointer;
		}
	}
	.icon {
	  order: 0;
	}

	.header {
	  order: 1;
	}

	::v-deep  {
		.v-color-picker__input input {
			background-color: rgba(25, 42, 62, 0.15);
		}
	}	
</style>